import clsx from 'clsx';
import SearchIcon from '../../assets/icons/search.svg';

export type SearchInputProps = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  gray?: boolean;
  className?: string;
};

export const SearchInput = ({
  placeholder,
  value,
  onChange,
  gray,
  className,
}: SearchInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div
      className={clsx(
        'w-full h-12 px-5 gap-4',
        'flex flex-row items-center rounded-full',
        'focus-within:ring-2 focus-within:ring-mui-blue-focus',
        gray ? 'bg-gray-d3' : 'bg-white',
        className
      )}
    >
      <img src={SearchIcon} alt="Buscar" height={24} />

      <input
        className={clsx(
          'w-full h-full border-none bg-transparent outline-none',
          'text-md placeholder:text-md placeholder-gray-3e/70'
        )}
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
      />
    </div>
  );
};
